<template>
	<v-overlay :model-value="offlineBlocked" persistent class="align-center justify-center">
		<v-card rounded="xl" max-width="440" class="nav-dialog">
			<v-card-title class="nav-dialog__title">
				<v-icon color="warning">wifi_off</v-icon>
				<span>{{ t('OfflineMode') }}</span>
			</v-card-title>
			<v-card-text>
				<p class="nav-dialog__text">{{ t('OfflineMode_NotAllowed') }}</p>
				<v-progress-linear indeterminate color="primary" rounded />
			</v-card-text>
		</v-card>
	</v-overlay>
</template>

<script setup>
import { useNetworkStatus } from '@/composables/useNetworkStatus';
import { useTranslator } from '@/composables/useTranslator';

const t = useTranslator();
const { offlineBlocked } = useNetworkStatus();
</script>
